import { Grid, Skeleton, Stack, Typography } from '@mui/material';
import { BlurredBox } from 'modules/common/components/BlurredBox';
import { ReactNode } from 'react';

interface IStatsBlockProps {
  title: string;
  mainValue: string;
  value: string;
  isLoading: boolean;
  content?: ReactNode;
}

export function StatsBlock({
  title,
  mainValue,
  value,
  isLoading,
  content,
}: IStatsBlockProps): JSX.Element {
  return (
    <Grid item xs={12} sm={6} md={6}>
      <BlurredBox
        sx={{
          padding: 3,
          borderRadius: 1.2,
        }}
      >
        <Typography variant="body1" color="text.secondary">
          {title}
        </Typography>
        <Stack
          flexDirection="row"
          alignItems="flex-end"
          justifyContent="space-between"
          mt={1.5}
        >
          {content || (
            <>
              {isLoading ? (
                <Skeleton width={125} height={40} />
              ) : (
                <Typography variant="h6">{mainValue}</Typography>
              )}
              {isLoading ? (
                <Skeleton width={85} height={20} />
              ) : (
                <Typography variant="body1" color="text.secondary">
                  {value}
                </Typography>
              )}
            </>
          )}
        </Stack>
      </BlurredBox>
    </Grid>
  );
}
